/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface AdminStockAdjustLocationBoxDimensionResVo
 */
export interface AdminStockAdjustLocationBoxDimensionResVo {
    /**
     * 箱ID
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionResVo
     */
    boxId?: number;
    /**
     * 长(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionResVo
     */
    length?: number;
    /**
     * 宽(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionResVo
     */
    width?: number;
    /**
     * 高(cm)
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionResVo
     */
    height?: number;
    /**
     * 尺寸展示，如 50 x 50 x 40
     * @type {string}
     * @memberof AdminStockAdjustLocationBoxDimensionResVo
     */
    dimensionSpec?: string;
    /**
     * 计费CBM
     * @type {number}
     * @memberof AdminStockAdjustLocationBoxDimensionResVo
     */
    cbm?: number;
}

/**
 * Check if a given object implements the AdminStockAdjustLocationBoxDimensionResVo interface.
 */
export function instanceOfAdminStockAdjustLocationBoxDimensionResVo(value: object): value is AdminStockAdjustLocationBoxDimensionResVo {
    return true;
}

export function AdminStockAdjustLocationBoxDimensionResVoFromJSON(json: any): AdminStockAdjustLocationBoxDimensionResVo {
    return AdminStockAdjustLocationBoxDimensionResVoFromJSONTyped(json, false);
}

export function AdminStockAdjustLocationBoxDimensionResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): AdminStockAdjustLocationBoxDimensionResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'boxId': json['boxId'] == null ? undefined : json['boxId'],
        'length': json['length'] == null ? undefined : json['length'],
        'width': json['width'] == null ? undefined : json['width'],
        'height': json['height'] == null ? undefined : json['height'],
        'dimensionSpec': json['dimensionSpec'] == null ? undefined : json['dimensionSpec'],
        'cbm': json['cbm'] == null ? undefined : json['cbm'],
    };
}

export function AdminStockAdjustLocationBoxDimensionResVoToJSON(json: any): AdminStockAdjustLocationBoxDimensionResVo {
    return AdminStockAdjustLocationBoxDimensionResVoToJSONTyped(json, false);
}

export function AdminStockAdjustLocationBoxDimensionResVoToJSONTyped(value?: AdminStockAdjustLocationBoxDimensionResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'boxId': value['boxId'],
        'length': value['length'],
        'width': value['width'],
        'height': value['height'],
        'dimensionSpec': value['dimensionSpec'],
        'cbm': value['cbm'],
    };
}

